import { render, staticRenderFns } from "./volume-set-unmanage.vue?vue&type=template&id=3f3b839a&scoped=true&"
import script from "./volume-set-unmanage.vue?vue&type=script&lang=js&"
export * from "./volume-set-unmanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b839a",
  null
  
)

export default component.exports